<template>
    <v-card>
        <v-card-title>
            <v-layout wrap>
                <v-flex xs12 lg10>
                    <h3 style="text-align: left;">{{ strings[idioma].suplementos }}</h3>
                </v-flex>
                <v-flex xs12 lg2>
                    <v-btn icon @click="novoSuplemento"> + </v-btn>
                </v-flex>
            </v-layout>
        </v-card-title>
        <hr />
        <v-card :style="'max-height: 300px!important; overflow: auto;'">
            <template v-if="listaSuplementos.length > 0">
                <v-list two-line dense flat rounded>
                    <template v-for="(alimento, index) in listaSuplementos">
                        <v-list-tile flat color="primary" @click="openAlimento(alimento)">
                            <v-list-tile-avatar>
                                <v-icon :class="'text-uppercase'" v-text="'mdi-folder'" />
                            </v-list-tile-avatar>
                            <v-list-tile-content style="min-width: 70%;">
                                <v-list-tile-title :class="'text-uppercase'">
                                    {{ alimento.nome }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                    {{ moment(alimento.updated_at.date).format(strings[idioma].formato_datas_com_hora) }}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>
                </v-list>
            </template>
            <template v-else>
                <div><span>{{strings[idioma].sem_resultado}}</span></div>
            </template>
        </v-card>
    </v-card>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex';
import { createMD5 } from '@/utils/utils'
export default {
    computed: {
        ...mapState('app', [
            'dietasAtivas',
            'data',
            'acesso_premium',
            'strings',
            'idioma',
            'user',
            'ingredientes',
            'optionsNumber',
            'alimentos_selecionados',
            'categorias_alimentos',
            'alimentos_usuario',
            'alert',
            'dietas',
            'predicoes',
            'tabelas',
            'empresa',
            'tabHome',
            'exibeTesteGratis'
        ]),
        listaSuplementos () {
            let data = this.data
            return (data.alimentos.usuario && data.alimentos.usuario.count >= 1) ? Object.values(data.alimentos.usuario)[1].filter(a => a.ingredientes && a.EXCLUIDO === 0) : []
        },
    },
    methods: {
        novoSuplemento() {
            window.location.href='/formulacao-suplemento'
        },
        openAlimento (al) {
            let alimento = Object.assign({}, al)
            alimento.nome_sci = alimento.nome_cientifico
            alimento.tipo = alimento.id_tipo
            let win = window.open('/formulacao-suplemento?alid='+ alimento.id + '&assinatura=' + createMD5(String(alimento.id)), '_blank')
            if (!win) window.location.href = '/formulacao-suplemento?alid='+ alimento.id + '&assinatura=' + createMD5(String(alimento.id))
        },
        moment (...args) {
            return moment(...args)
        },
    }
}
</script>